/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ImportJobMetadataFromJSON, ImportJobMetadataToJSON, ImportJobStatusFromJSON, ImportJobStatusToJSON, } from './';
export function UpdateImportJobRequestFromJSON(json) {
    return UpdateImportJobRequestFromJSONTyped(json, false);
}
export function UpdateImportJobRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        title: !exists(json, 'title') ? undefined : json['title'],
        description: !exists(json, 'description') ? undefined : json['description'],
        status: !exists(json, 'status') ? undefined : ImportJobStatusFromJSON(json['status']),
        metadata: !exists(json, 'metadata') ? undefined : ImportJobMetadataFromJSON(json['metadata']),
        labels: !exists(json, 'labels') ? undefined : json['labels'],
    };
}
export function UpdateImportJobRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        title: value.title,
        description: value.description,
        status: ImportJobStatusToJSON(value.status),
        metadata: ImportJobMetadataToJSON(value.metadata),
        labels: value.labels,
    };
}
